import { api } from '..'

export const assignDeviceToAlertRule =
  (alertRuleId: string, deviceId: string) => () =>
    api.post(`/v1/alert-rules/${alertRuleId}/devices`, {
      devicesId: [deviceId],
    })
